// Copyright © 2017-2020  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC.

<template>
  <v-container fluid grid-list-md>
    <v-row wrap>
      <v-col cols="12" justify-center>
        <v-card>
          <v-progress-linear :indeterminate="loading" style="margin-top: 0px;"></v-progress-linear>
          <v-card-text>
            <v-row wrap>
              <v-col cols="12">
                <v-autocomplete
                        clearable
                        :label="'Zones'"
                        :item-text="item => item.name"
                        :item-value="item => item._id"
                        :items="zones"
                        :value="selectedZones"
                        @input="(val) => selectedZones = val"
                        :multiple="true"
                        :chips="true"
                        deletable-chips
                        :small-chips="true"
                        hide-details
                        :required="true"
                      ></v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                        clearable
                        :label="'Categories'"
                        :item-text="item => item.name"
                        :item-value="item => item.id"
                        :items="categories"
                        :value="selectedCategories"
                        @input="(val) => selectedCategories = val"
                        :multiple="true"
                        :chips="true"
                        deletable-chips
                        :small-chips="true"
                        hide-details
                        :required="true"
                      ></v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-btn class="mx-1" @click="allZones()">All Zones</v-btn>
                <v-btn class="mx-1" @click="getReport()">Run Report</v-btn>
                <v-btn class="mx-1" @click="downloadReport()">Download XLS</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row wrap>
      <v-col cols="12" v-for="zone in report.zones" :key="zone.id">
        <v-card>
          <div style="padding: 12px; padding-left: 24px; padding-right: 24px; ">
            <v-row wrap>
              <v-col cols="12" class="font-weight-bold">
                Zone: {{ zone.name }}
              </v-col>
              <!-- <v-flex xs12>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-flex> -->
              <v-col cols="4">
                <v-data-table
                  :pagination="pagination"
                  :items="nonzeroReportItems(zone)"
                  item-key="id"
                  :headers="headers">
                  <template v-slot:items="props">

                    <td xs3 class="text-xs-left">{{ props.item.name }}</td>
                    <td xs1 class="text-xs-right">{{ props.item.count }}</td>
                  </template>
                </v-data-table>
                <!-- <v-flex xs12 v-for="category in nonzeroReports(zone)" :key="category.id">

                    {{ category.name }} {{ category.count }}

                </v-flex> -->
              </v-col>

            </v-row>
          </div>
        </v-card>
        </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

import ApiRequests from '@/api/ApiRequests'
import ChartBar from '@/components/ChartBar.js'
import DateTimeView from '@/components/DateTimeView'

import {LookupMixin, TimeMixin} from '@/shared/mixins'

export default {
  components: {
    DateTimeView,
    ChartBar
  },

  mixins: [LookupMixin, TimeMixin],

  data () {
    return {
      chartData: {},
      chartOptions: {
        maintainAspectRatio: false
      },
      dateStart: (moment().startOf('day')),
      dateEnd: (moment().add(1, 'days').startOf('day')),
      data: [],
      events: [],
      loading: false,
      panel: [],
      showGraph: false,
      things: [],
      totalHours: 0,
      zones: [],
      selectedZones: [],
      categories: [],
      selectedCategories: [],
      report: [],
      headers: [
        {
          text: 'Name',
          value: 'name',
          sortable: true
        },
        {
          text: 'Count',
          value: 'count',
          align: 'right',
          sortable: true
        }
      ],
      pagination: {
        rowsPerPage: -1
      }
    }
  },

  created () {
    Promise.all([
      ApiRequests.getZones(this.selectedSite._id).then((r) => {
        this.zones = r.data
      }),
      ApiRequests.getImageCategories().then((r) => {
        this.categories = r.data
      })
    ])
  },

  computed: {
    ...mapGetters([
      'selectedSite',
      'user'
    ])
  },

  methods: {
    getReport: function () {
      ApiRequests.getAdhocReportJson({
        'type': 'reportTypeCategories',
        'format': 'json',
        'site': this.selectedSite._id,
        'categories': this.selectedCategories,
        'zones': this.selectedZones
      }).then((r) => {
        this.report = r.data
      })
    },
    nonzeroReports: function (zoneReport) {
      if (zoneReport.name === 'Summary') {
        return zoneReport.categoryCounts
      }
      let map = {}
      for (let property in zoneReport.categoryCounts) {
        let v = zoneReport.categoryCounts[property]
        if (v.count > 0) {
          map[property] = v
        }
      }
      return map
    },
    nonzeroReportItems: function (zoneReport) {
      let map = []
      for (let property in zoneReport.categoryCounts) {
        let v = zoneReport.categoryCounts[property]
        if (zoneReport.name === 'Summary' || v.count > 0) {
          map.push(v)
        }
      }
      return map
    },
    downloadReport: function () {
      ApiRequests.getAdhocReportBlob({
        'type': 'reportTypeCategories',
        'format': 'excel',
        'site': this.selectedSite._id,
        'categories': this.selectedCategories,
        'zones': this.selectedZones
      }).then((r) => {
        console.log(r.data)
        const blob = new Blob(
          [
            // Buffer.from(r.data, 'base64')
            r.data
          ],
          {
            type: 'application/octet-stream'
          }
        )
        const blobUrl = URL.createObjectURL(blob)

        const anchor = document.createElement('a')
        anchor.href = blobUrl
        anchor.setAttribute('download', 'report.xlsx')
        // Safari thinks _blank anchor are pop ups. We only want to set _blank
        // target if the browser does not support the HTML5 download attribute.
        // This allows you to download files in desktop safari if pop up blocking
        // is enabled.
        if (typeof anchor.download === 'undefined') {
          anchor.setAttribute('target', '_blank')
        }
        anchor.download = 'report.xlsx'
        anchor.click()
        setTimeout(() => URL.revokeObjectURL(blobUrl), 100)
      })
    },
    allZones: function () {
      this.selectedZones = this.zones.map((i) => i._id)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ReportZoneCategories.vue